import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import styled, { keyframes } from 'styled-components'

import ImageWithFallback from '@/utilities/client-components/components/Icon/ImageWithFallback'
import * as themeUtilities from '@/utilities/client-components/utilities/themeUtils'

// TODO there's an opportunity here to add height animations but with eyes on an "infinite scroller" we can defer it for now

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

const StyledPendingInline = styled.div`
  display: flex;
  color: ${({ theme, rootContainer }: any) => themeUtilities.getColor(theme, rootContainer, 'dark')};
  max-width: 400px;
  flex-direction: row;
  align-items: center;
  font-size: 11px;
  padding: 13px 5px 13px 10px;
  border: 1px solid ${({ theme, rootContainer }: any) => themeUtilities.getColor(theme, rootContainer, 'light')};
  border-radius: 6px;
  margin: 16px auto;
  opacity: 0;
  animation: ${fadeIn} 500ms linear;
  animation-fill-mode: forwards;
`

const StyledPendingImage = styled(ImageWithFallback)`
  flex: 0 0 45px;
  width: 45px;
  height: 100%;
  margin-right: 5px;
`

const StyledDetail = styled.div`
  flex: 1;
`

const StyledTitle = styled.div`
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 4px;
`

const StyledStatus = styled.div`
  .pending {
    color: ${({ theme, rootContainer }: any) => themeUtilities.getColor(theme, rootContainer, 'default')};
  }
`

interface PendingInlineProps {
  notification: object
}

const PendingInline = ({ notification }: PendingInlineProps) => {
  const { t } = useTranslation('client')
  const ref = useRef()

  // TODO Bring rootContainer into the PendingInline from summary
  const rootContainer = 'light'

  return (
    // @ts-expect-error
    <StyledPendingInline ref={ref} key={notification.id} data-id="wg-pending" rootContainer={rootContainer}>
      {/* @ts-expect-error */}
      <StyledPendingImage src={notification.source.iconUrl} alt={notification.source.iconAlt} />
      <StyledDetail>
        {/* @ts-expect-error */}
        <StyledTitle>{notification.title}</StyledTitle>
        {/* @ts-expect-error */}
        <StyledStatus rootContainer={rootContainer}>
          {t('client:PendingInline.status')} <span className="pending">{t('client:PendingInline.queued')}</span>{' '}
          {t('client:PendingInline.viewMore')}
        </StyledStatus>
      </StyledDetail>
    </StyledPendingInline>
  )
}

PendingInline.displayName = 'PendingInline'

export default PendingInline
